export const AgentOfficePages = {
	AgentOfficeSetup: {
		name: "agent-office-setup",
		displayName: "Agent Office Setup",
	},
	AgentOfficeEdit: {
		name: "edit-agent-office",
		displayName: "Edit Agent Office",
	},
};
